import {fromJS} from 'immutable';
import {SET_END_OF_STREAM_REFLECTED} from '../general/consts'
import {
  AUDIO_SET_ENABLED,
  AUDIO_SET_VAD_ENABLED,
  AUDIO_SET_STT_ENABLED,
  AUDIO_START,
  AUDIO_STOP,
  AUDIO_TRANSCRIBE_REQUEST,
  AUDIO_TRANSCRIBE_RESULT,
  AUDIO_ERROR,
  AUDIO_SET_HEARING,
  AUDIO_SET_ROBOT_SPEAKING,
  ENABLED,
  VAD_ENABLED,
  STT_ENABLED,
  IS_TRANSCRIBING,
  LAST_ERROR,
  ROBOT_SPEAKING,
  HEARING,
  HIGHLIGHT_RANGE, SET_HIGHLIGHT_RANGE,
} from './consts'

const initialState = fromJS({
  [ENABLED]: true,
  [VAD_ENABLED]: true,
  [STT_ENABLED]: true,
  [IS_TRANSCRIBING]: false,
  [LAST_ERROR]: null,
  [HEARING]: 'silence',
  [ROBOT_SPEAKING]: false,
  [HIGHLIGHT_RANGE]: { start: -1, end: -1 },
})

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  switch (action.type) {
    case AUDIO_SET_ENABLED:
      return state.set(ENABLED, action.enabled)

    case AUDIO_SET_VAD_ENABLED:
      return state.set(VAD_ENABLED, action.enabled)

    case AUDIO_SET_STT_ENABLED:
      return state.set(STT_ENABLED, action.enabled)

    case AUDIO_TRANSCRIBE_REQUEST:
      return state.set(IS_TRANSCRIBING, true)

    case AUDIO_TRANSCRIBE_RESULT:
      return state.set(IS_TRANSCRIBING, false)

    case AUDIO_ERROR:
      return state.set(LAST_ERROR, String(action.error || 'unknown audio error'))
        .set(IS_TRANSCRIBING, false)

    case AUDIO_SET_HEARING:
      return state.set(HEARING, action.hearing)

    case AUDIO_SET_ROBOT_SPEAKING:
      return state.set(ROBOT_SPEAKING, !!action.speaking)

    case SET_HIGHLIGHT_RANGE:
      return state.set(HIGHLIGHT_RANGE, fromJS(action.payload))

    default:
      return state;
  }
}
